/* 
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved. */


/* @license
Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt */

import '../behaviors/sb-app-storage-behavior.js';
import { Polymer } from '@polymer/polymer/polymer-legacy.js';

    'use strict';

    /**
     * sb-app-localstorage-document synchronizes storage between an in-memory
     * value and a location in the browser's localStorage system.
     *
     * localStorage is a simple and widely supported storage API that provides both
     * permanent and session-based storage options. Using sb-app-localstorage-document
     * you can easily integrate localStorage into your app via normal Polymer
     * databinding.
     *
     * sb-app-localstorage-document is the reference implementation of an element
     * that uses `AppStorageBehavior`. Reading its code is a good way to get
     * started writing your own storage element.
     *
     * Example use:
     *
     *     <paper-input value="{{search}}"></paper-input>
     *     <sb-app-localstorage-document key="search" data="{{search}}">
     *     </sb-app-localstorage-document>
     *
     * sb-app-localstorage-document automatically synchronizes changes to the
     * same key across multiple tabs.
     *
     * Only supports storing JSON-serializable values.
     */
   Polymer({
      is: 'sb-app-localstorage-document',
      behaviors: [
        sbBehaviours.SbAppStorageBehavior
      ],

      properties: {
        /**
         * Defines the logical location to store the data.
         */
        key: {
          type: String,
          notify: true
        },

        /**
         * If true, the data will automatically be cleared from storage when
         * the page session ends (i.e. when the user has navigated away from
         * the page).
         */
        sessionOnly: {
          type: Boolean,
          value: false
        },

        /**
         * Either `window.localStorage` or `window.sessionStorage`, depending on
         * `this.sessionOnly`.
         */
        storage: {
          type: Object,
          computed: '__computeStorage(sessionOnly)'
        }
      },

      observers: [
        '__storageSourceChanged(storage, key)'
      ],

      attached: function () {
        this.listen(window, 'storage', '__onStorage');
        this.listen(
          window.top,
          'app-local-storage-changed',
          '__onAppLocalStorageChanged');
      },

      detached: function () {
        this.unlisten(window, 'storage', '__onStorage');
        this.unlisten(
          window.top,
          'app-local-storage-changed',
          '__onAppLocalStorageChanged');
      },

      /**
       * @override
       */
      get isNew() {
        return !this.key;
      },

      /**
       * Stores a value at the given key, and if successful, updates this.key.
       *
       * @override
       * @param {string} key The new key to use.
       */
      save: function (key) {
        try {
          this.__setStorageValue(key, this.data);
        } catch (e) {
          return Promise.reject(e);
        }

        this.key = key;

        return Promise.resolve();
      },

      /**
       * @override
       */
      reset: function () {
        this.key = null;
        this.data = this.zeroValue;
      },

      /**
       * @override
       */
      destroy: function () {
        try {
          this.storage.removeItem(this.key);
          this.reset();
        } catch (e) {
          return Promise.reject(e);
        }

        return Promise.resolve();
      },

      /**
       * @override
       */
      getStoredValue: function (path) {
        var value;

        if (this.key != null) {
          try {
            value = this.__parseValueFromStorage();

            if (value != null) {
              value = this.get(path, {
                data: value
              });
            } else {
              value = undefined;
            }
          } catch (e) {
            return Promise.reject(e);
          }
        }

        return Promise.resolve(value);
      },

      /**
       * @override
       */
      setStoredValue: function (path, value) {
        if (this.key != null) {
          try {
            this.__setStorageValue(this.key, this.data);
          } catch (e) {
            return Promise.reject(e);
          }

          this.fire('app-local-storage-changed', this, {
            node: window.top
          });
        }

        return Promise.resolve(value);
      },

      __computeStorage: function (sessionOnly) {
        return sessionOnly ? window.sessionStorage : window.localStorage;
      },

      __storageSourceChanged: function () {
        this._initializeStoredValue();
      },

      __onStorage: function (event) {
        if (event.key !== this.key ||
          event.storageArea !== this.storage) {
          return;
        }

        this.syncToMemory(function () {
          this.set('data', this.__parseValueFromStorage());
        });
      },

      __onAppLocalStorageChanged: function (event) {
        if (event.detail === this ||
          event.detail.key !== this.key ||
          event.detail.storage !== this.storage) {
          return;
        }
        this.syncToMemory(function () {
          this.set('data', event.detail.data);
        });
      },

      //       convertType: function(value){
      //   var values = {undefined: undefined, null: null, true: true, false: false}
      //      ,isNumber = !isNaN(+(value));
     
      //   return isNumber && +(value) || !(value in values) && value || values[value];
      // },

      __parseValueFromStorage: function () {
   
        if (this.storage[this.key + "_OBJ"]) {
        //  log.debug("In app-localstorage : Found STR : key : " + this.key + "_STR");

          var savedvalue = this.storage.getItem(this.key + "_OBJ");
          var decryptedvalue = sbEncrypt.decrypt(savedvalue);
        
          var result = JSON.parse(decryptedvalue);
          return result;
        }
        else if (this.storage[this.key + "_STR"]) {
       
          let savedvalue = this.storage.getItem(this.key + "_STR");
          let decryptedvalue = sbEncrypt.decrypt(savedvalue);
          // var convertedValue=this.convertType(decryptedvalue);
          return decryptedvalue;
        }
        else {
          if (this.storage[this.key]) {
            let savedvalue = this.storage[this.key];
            let decryptedvalue = sbEncrypt.decrypt(savedvalue);
 

            try {
              this.result = JSON.parse(decryptedvalue);
              return this.result;
            }

            catch (err) {
              //  var convertedValue=this.convertType(decryptedvalue);
              return decryptedvalue;

            }
          }
          else {

            return null;
          }
        }


      },



      __setStorageValue: function (key, value) {
        try {
           //log.debug("**inside SET app-local : key : " + this.key + " n value : " + value);


          if (this.storage[this.key + "_OBJ"]) {
           // log.debug(this.key + "_OBJ" + "Key exists in appstorage**");
            let encryptedvalue = sbEncrypt.encrypt(value);
            this.storage.setItem(this.key + "_OBJ", encryptedvalue.toString());
            return;
          }
          else if (this.storage[this.key + "_STR"]) {
       
            let encryptedvalue = sbEncrypt.encrypt(value);
            this.storage.setItem(this.key + "_STR", encryptedvalue.toString());
            return;
          }

          else {
            if (value == undefined || value == null || value == "" || typeof (value) === 'number' || typeof (value) === 'boolean') {
              this.storage.setItem(this.key, value);
          
              return;
            }
            else {
              if (typeof (value) === 'object') {
                let encryptedvalue = sbEncrypt.encrypt(value);
     
                this.storage.setItem(this.key + "_OBJ", encryptedvalue.toString());
                return;
              }

              else {
                let encryptedvalue = sbEncrypt.encrypt(value);
         
                this.storage.setItem(this.key + "_STR", encryptedvalue.toString());
                return;
              }

            }

          }
        }
        catch (err) {
          //eslint issue
        }
      }
    });
